export default "__VITE_ASSET__CJkHrbmU__"